import type { TFunction } from 'i18next';

import { Icon, Tooltip } from '~/components';
import type { DropdownOption } from '~/components/Dropdown';

const createOption = (
  t: TFunction,
  key: string,
  value: string,
  tooltipKey?: string,
): DropdownOption => {
  const hasTooltip = Boolean(tooltipKey && t(tooltipKey));

  const content = (
    <div className="flex items-baseline">
      <p className="mr-sm">{t(key)}</p>
      {hasTooltip ? (
        <Tooltip
          content={
            <div className="flex flex-col gap-sm leading-5">
              <p>{t(tooltipKey!)}</p>
            </div>
          }
          delayDuration={0}
          sideOffset={16}
          side="top"
          align="end"
          triggerAsChild
          size="md"
        >
          <span className="flex">
            <Icon
              className="cursor-pointer"
              type="circle-info"
              variant="light"
              size="sm"
            />
          </span>
        </Tooltip>
      ) : null}
    </div>
  );

  return {
    label: t(key),
    value,
    renderSelected: () => content,
    render: () => content,
  };
};

export const getReleaseOptions = (t: TFunction): DropdownOption[] => [
  createOption(t, 'table.dropdown.releases.options.allVintages', 'all'),
  createOption(
    t,
    'table.dropdown.releases.options.newRelease',
    'new',
    'tooltips.vintagesNew',
  ),
  createOption(
    t,
    'table.dropdown.releases.options.shallowCatalog',
    'shallow',
    'tooltips.vintagesShallow',
  ),
  createOption(
    t,
    'table.dropdown.releases.options.deepCatalog',
    'deep',
    'tooltips.vintagesDeep',
  ),
];
